var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 13.18L11.13 9.70999C12.63 7.53999 12.42 4.54999 10.49 2.61999C8.32 0.449993 4.8 0.449993 2.63 2.61999C0.459999 4.78999 0.459999 8.30999 2.63 10.48C4.56 12.41 7.55 12.61 9.72 11.12L13.19 14.59C13.58 14.98 14.21 14.98 14.6 14.59C14.99 14.21 14.99 13.57 14.6 13.18ZM4.04 9.07999C2.65 7.68999 2.65 5.42999 4.04 4.03999C5.43 2.64999 7.69 2.64999 9.08 4.03999C10.47 5.42999 10.47 7.68999 9.08 9.07999C7.69 10.47 5.43 10.47 4.04 9.07999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9b2c33f423338177bfc977d6e04386ba.svg";
export { ForwardRef as ReactComponent };